import { render, staticRenderFns } from "./modal_company.vue?vue&type=template&id=7b4f5577"
import script from "./modal_company.js?vue&type=script&lang=js&external"
export * from "./modal_company.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports